import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0 n20-container",
    attrs: {
      "fluid": "",
      "data-cy": "virtual_device_container"
    }
  }, [_c('core-n20-dialog', {
    attrs: {
      "isOpen": _vm.commentDialogIsOpen
    },
    on: {
      "close": _vm.closeCommentDialog
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-save"
          },
          on: {
            "click": _vm.saveComment
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('Common.save')) + "\n      ")])];
      },
      proxy: true
    }])
  }, [_c(VTextarea, {
    staticClass: "mt-3 mb-2",
    attrs: {
      "type": "text",
      "rows": "5",
      "label": _vm.$t('AlarmLogs.commentLabel'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": ""
    },
    model: {
      value: _vm.commentText,
      callback: function ($$v) {
        _vm.commentText = $$v;
      },
      expression: "commentText"
    }
  })], 1), _c(VRow, {
    class: _vm.containerClass,
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm.isEmptyList ? _c('core-n20Card', [_c('core-empty-state', {
    attrs: {
      "icon": "fa-sensor-alert",
      "color": _vm.color
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function () {
        return [_vm._v("\n            " + _vm._s(_vm.$i18n_t('AlarmLogs.emptyState.title')) + "\n          ")];
      },
      proxy: true
    }], null, false, 548674678)
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$i18n_t('AlarmLogs.emptyState.text')) + "\n          ")])])], 1) : _c('core-n20Card', [_c('custom-multi-search', {
    attrs: {
      "data-cy": "quick_search",
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "operator": _vm.searchOperator,
      "dense": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  }), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('core-button', {
    attrs: {
      "dense": "",
      "color": _vm.color,
      "disabled": !_vm.canComment
    },
    on: {
      "click": function ($event) {
        _vm.commentDialogIsOpen = true;
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('AlarmLogs.addComment')) + "\n          ")])], 1), _c(VDataTable, {
    staticClass: "row-pointer",
    attrs: {
      "data-cy": "alarm_logs_data_table",
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "single-select": false,
      "show-select": "",
      "item-key": "id",
      "page": _vm.tableOptions.page,
      "show-expand": "",
      "single-expand": "",
      "expanded": _vm.expanded
    },
    on: {
      "update:options": function ($event) {
        _vm.tableOptions = $event;
      },
      "update:page": function ($event) {
        return _vm.$set(_vm.tableOptions, "page", $event);
      },
      "update:expanded": function ($event) {
        _vm.expanded = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "item.data-table-expand",
      fn: function ({
        item,
        isExpanded,
        expand
      }) {
        return [item.children.length !== 0 ? _c(VIcon, {
          staticClass: "ml-2",
          attrs: {
            "size": "14"
          },
          on: {
            "click": function ($event) {
              return expand(!isExpanded);
            }
          }
        }, [_vm._v("\n              " + _vm._s(isExpanded ? 'far fa-chevron-up' : 'far fa-chevron-down') + "\n            ")]) : _vm._e()];
      }
    }, {
      key: "item.severity",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "small": "",
            "color": item.severity === 'error' ? 'danger' : 'warning'
          }
        }, [_vm._v("\n              fa fa-exclamation-triangle\n            ")])];
      }
    }, {
      key: "item.isResolved",
      fn: function ({
        item
      }) {
        return [item.isResolved ? _c(VIcon, {
          attrs: {
            "small": "",
            "color": "success"
          }
        }, [_vm._v("fa fa-check-circle")]) : _vm._e()];
      }
    }, {
      key: "item.timestamp",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.timestamp)) + "\n          ")];
      }
    }, {
      key: "item.logCategory",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.$t(`AlarmLogs.categories.${item.logCategory || 'unknown'}`)) + "\n          ")];
      }
    }, {
      key: "item.message",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "350px"
          },
          attrs: {
            "title": item.message
          }
        }, [_vm._v("\n              " + _vm._s(item.message) + "\n            ")])];
      }
    }, {
      key: "item.virtualDevice.title",
      fn: function ({
        item
      }) {
        return [item.originType === 'smartgroup-packet-monitoring' ? [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "200px"
          },
          attrs: {
            "title": item.smartGroup.title
          }
        }, [_c('router-link', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "200px"
          },
          attrs: {
            "to": `/virtual-device-groups/${item.smartGroup.id}`
          }
        }, [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-object-group")]), _vm._v("\n                  (Id: " + _vm._s(item.smartGroup.id) + ") " + _vm._s(item.smartGroup.title) + "\n                ")], 1)], 1)] : [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "200px"
          },
          attrs: {
            "title": item.title
          }
        }, [_c('router-link', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "200px"
          },
          attrs: {
            "to": `/virtual-devices/${item.virtualDevice.id}`
          }
        }, [_c(VIcon, {
          attrs: {
            "small": ""
          }
        }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n                  (Id: " + _vm._s(item.virtualDevice.id) + ") " + _vm._s(item.title) + "\n                ")], 1)], 1)]];
      }
    }, {
      key: "item.tenantId",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticClass: "text-truncate",
          staticStyle: {
            "max-width": "100px"
          },
          attrs: {
            "title": _vm.getTenantNameById(item.tenantId)
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getTenantNameById(item.tenantId)) + "\n            ")])];
      }
    }, {
      key: "item.virtualDevice.operationalStatus",
      fn: function ({
        item
      }) {
        return [item.originType === 'smartgroup-packet-monitoring' ? [_vm._v("-")] : [_vm._v("\n              " + _vm._s(_vm.operationalStatus[item.virtualDevice.operationalStatus]) + "\n            ")]];
      }
    }, {
      key: "expanded-item",
      fn: function ({
        headers,
        item
      }) {
        return [_c('td', {
          attrs: {
            "colspan": 5
          }
        }), _c('td', {
          staticStyle: {
            "vertical-align": "top"
          }
        }, _vm._l(item.children, function (child, index) {
          return _c('p', {
            key: `${item.id}_${index}`
          }, [_vm._v("\n                " + _vm._s(_vm.localizeDate(child.timestamp)) + "\n              ")]);
        }), 0), _c('td', {
          staticStyle: {
            "vertical-align": "top"
          }
        }, _vm._l(item.children, function (child, index) {
          return _c('p', {
            key: `${item.id}_${index}`
          }, [child.logType === 'ALARM' ? _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "small": "",
              "color": "danger"
            }
          }, [_vm._v("\n                  fa fa-exclamation-triangle\n                ")]) : child.logType === 'RESOLVE' ? _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "small": "",
              "color": "success"
            }
          }, [_vm._v("\n                  fa fa-check-circle\n                ")]) : _c(VIcon, {
            staticClass: "mr-2",
            attrs: {
              "small": ""
            }
          })], 1);
        }), 0), _c('td', {
          staticStyle: {
            "white-space": "pre"
          },
          attrs: {
            "colspan": 3
          }
        }, _vm._l(item.children, function (child, index) {
          return _c('p', {
            key: `${item.id}_${index}`
          }, [_vm._v(_vm._s(_vm.getMsg(child.message)))]);
        }), 0)];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_vm._v("\n            " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n          ")];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.selectedRows,
      callback: function ($$v) {
        _vm.selectedRows = $$v;
      },
      expression: "selectedRows"
    }
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };